/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { MsgIDs } from '@/defines/MsgIDs'
import { Utility } from '@/utils/TimeUtils'
import { base } from '@/base/base'
import { PopupViews } from '@/defines/EnumDefine'
import { FunctionUtils } from '@/utils/FunctionUtils'
import { wsClient } from '@/net/WebSocketClient'

export class RankModule extends ModuleBase {
  public lastClickTime = 0 //上一次打开界面的时间，30min倒计时
  public changeHallFractionTime = 300 //120s刷新分数（最少也得20s）
  public rankTextCishu = 20 //分数每次变化要经过几次才能变化完成
  public rankListMax = 100 //最多展示多少名

  public dailyEndTime = 0 //每日结束倒计时
  public weeklyEndTime = 0 //每周结束倒计时

  public dailyList: any[] = [] //当日排行榜列表
  public lastDailyList: any[] = [] //昨日排行榜列表
  public weeklyList: any[] = [] //本周排行榜列表
  public lastWeeklyList: any[] = [] //上周排行榜列表

  public dailyFrction = 0 //当日排行榜分数
  public lastDailyFrction = 0 //昨日排行榜分数
  public weeklyFrction = 0 //本周排行榜分数
  public lastWeeklyFrction = 0 //上周排行榜分数

  //分数倒计时（直接这里存每次变动的分数，然后打开就按这个数据加载），保持大厅和排行榜界面分数差不多。

  public _rankDailyFaction = 0 //排行榜每日保存分数
  public _rankWeeklyFaction = 0 //排行榜每周保存分数

  public dailyRewardBeginTime = 0 //后端传的数据
  public dailyRewardEndTime = 0 //后端传的数据
  public weeklyRewardBeginTime = 0 //后端传的数据
  public weeklyRewardEndTime = 0 //后端传的数据

  public dailyTipTime = 0
  public weeklyTipTime = 0
  public weeklyTipTimeEnd = 0

  public popInfoReward = 0
  public popInfoType = 0
  public popInfoRank = 0
  public popOpen = true

  public haveInfo = false
  public timePanel: any = null
  public isFirst = false
  public rankRed = false

  public hallJackpotNode: any = null

  init(): void {
    this.dailyList = []
    this.lastDailyList = []
    this.weeklyList = []
    this.lastWeeklyList = []
    this.dailyEndTime = 0
    this.weeklyEndTime = 0
    this.lastClickTime = 0
    this.dailyFrction = 0
    this.lastDailyFrction = 0
    this.weeklyFrction = 0
    this.lastWeeklyFrction = 0
    this.dailyTipTime = 0
    this.weeklyTipTime = 0
    this.weeklyTipTimeEnd = 0
    this.popInfoReward = 0
    this.popInfoType = 0
    this.popInfoRank = 0
    this.haveInfo = false
    this.rankRed = false
  }

  onClear(): void {
    this.dailyList = []
    this.lastDailyList = []
    this.weeklyList = []
    this.lastWeeklyList = []
    this.dailyEndTime = 0
    this.weeklyEndTime = 0
    this.lastClickTime = 0
    this.dailyFrction = 0
    this.lastDailyFrction = 0
    this.weeklyFrction = 0
    this.lastWeeklyFrction = 0
    this.dailyTipTime = 0
    this.weeklyTipTime = 0
    this.weeklyTipTimeEnd = 0
    this.popInfoReward = 0
    this.popInfoType = 0
    this.popInfoRank = 0
    this.haveInfo = false
    this.isFirst = false
    this.rankRed = false
    if (hall.rankModule.timePanel) {
      Utility.cancelTimer(hall.rankModule.timePanel)
    }
    hall.rankModule.timePanel = null
  }
  onLoad(): void {}
  onDestroy(): void {}
  onPreloadData(): void {
    //console.log("load----------")
    if (hall.userModule.userId == 1) {
      return
    }
    this.sendRewardInfo()
    this.sendRankDailyInfo()
  }

  inits2c(): void {
    //今天
    ;(hall.s2c as any)['onClientRankingDataAck'] = (msg: any) => {
      base.uiHudSystem.hide('SystemWaiting')

      // uint32 ret = 1;
      // uint32 RankType = 2;  // 排行榜类型(1:日,2:周,3:历史日,4:历史周)
      // uint32 reqUser = 3;    // 请求玩家ID
      // repeated RankingStu RankData = 4; // 排行榜数据

      // message RankingStu
      // {
      // uint32 Ranking = 1; // 排名
      // uint32 UserID = 2; // 玩家ID
      // string NickName = 3;  //昵称
      // string HeaderURL = 4;  //头像
      // uint64 ActBetGold = 5; // 有效下注金额(x100)
      // }
      if (msg.ret == 0) {
        if (msg.RankType == 1) {
          hall.rankModule.dailyList = msg.RankData
          hall.eventDispatcher.emit(hall.EventDefine.ChangeRankList, 0)
        } else if (msg.RankType == 3) {
          hall.rankModule.lastDailyList = msg.RankData
          hall.eventDispatcher.emit(hall.EventDefine.ChangeRankList, 1)
        } else if (msg.RankType == 2) {
          hall.rankModule.weeklyList = msg.RankData
          hall.eventDispatcher.emit(hall.EventDefine.ChangeRankList, 2)
        } else if (msg.RankType == 4) {
          hall.rankModule.lastWeeklyList = msg.RankData
          hall.eventDispatcher.emit(hall.EventDefine.ChangeRankList, 3)
        }

        hall.rankModule.haveInfo = true
        if (msg.RankType == 1) {
          hall.rankModule.dailyEndTime = (msg.Endtime - msg.Nowtime) * 1000
          hall.rankModule.dailyFrction = msg.Jackpot
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 0)
        } else if (msg.RankType == 3) {
          hall.rankModule.lastDailyFrction = msg.Jackpot
          this.dailyTipTime = msg.Endtime
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 1)
        } else if (msg.RankType == 2) {
          hall.rankModule.weeklyEndTime = (msg.Endtime - msg.Nowtime) * 1000
          hall.rankModule.weeklyFrction = msg.Jackpot
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 2)
        } else if (msg.RankType == 4) {
          hall.rankModule.lastWeeklyFrction = msg.Jackpot
          this.weeklyTipTime = msg.Begintime
          this.weeklyTipTimeEnd = msg.Endtime
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 3)
        }
      }
    }

    //倒计时和分数
    ;(hall.s2c as any)['onClientRankingJackPotAck'] = (msg: any) => {
      console.log('onClientRankingJackPotAck')
      base.uiHudSystem.hide('SystemWaiting')
      //         uint32 ret = 1;
      //uint32 UserID = 2;    // 玩家ID
      //uint32 RankType = 3;  // 排行榜类型(1:日,2:周,3:历史日,4:历史周)
      //uint64 Jackpot = 4;   // JackPot金额
      //uint64 Begintime = 5; // 开始时间
      //uint64 Endtime = 6;   // 结束时间
      //uint64 Nowtime = 7;   // 当前时间(历史数据为0)

      if (msg.ret == 0) {
        hall.rankModule.haveInfo = true
        if (msg.RankType == 1) {
          hall.rankModule.dailyEndTime = (msg.Endtime - msg.Nowtime) * 1000
          hall.rankModule.dailyFrction = msg.Jackpot
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 0)
        } else if (msg.RankType == 3) {
          hall.rankModule.lastDailyFrction = msg.Jackpot
          this.dailyTipTime = msg.Endtime
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 1)
        } else if (msg.RankType == 2) {
          hall.rankModule.weeklyEndTime = (msg.Endtime - msg.Nowtime) * 1000
          hall.rankModule.weeklyFrction = msg.Jackpot
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 2)
        } else if (msg.RankType == 4) {
          hall.rankModule.lastWeeklyFrction = msg.Jackpot
          this.weeklyTipTime = msg.Begintime
          this.weeklyTipTimeEnd = msg.Endtime
          hall.eventDispatcher.emit(hall.EventDefine.ChangeHallRankFraction, msg.Jackpot, 3)
        }
      }
    }

    //返回排行榜未领取的奖励数据
    ;(hall.s2c as any)['onClientRankingPrizeGoldAck'] = (msg: any) => {
      // uint32 UserID = 1;        // 玩家ID

      // 	uint64 Prize_date = 2;    // 中奖金额(x100)
      // 	uint32 Rankid_date = 3;   // 排名
      // 	uint64 Tbegin_date = 4;   // 日开始时间
      // 	uint64 Tend_date = 5;     // 日结束时间

      // 	uint64 Prize_sunday = 6;  // 中奖金额(x100)
      // 	uint32 Rankid_sunday = 7; // 排名
      // 	uint64 Tbegin_sunday = 8; // 周开始时间
      // 	uint64 Tend_sunday = 9;   // 周结束时间
      if (msg) {
        if (msg.PrizeDate > 0) {
          this.dailyRewardBeginTime = msg.TbeginDate
          this.dailyRewardEndTime = msg.TendDate
          hall.rankModule.hasRewardInfo(msg.PrizeDate, 0, msg.RankidDate)
          hall.eventDispatcher.emit(hall.EventDefine.RankRewardGet)

          //hall.rankModule.popupView();
        } else {
          if (msg.PrizeSunday > 0) {
            this.weeklyRewardBeginTime = msg.TbeginSunday
            this.weeklyRewardEndTime = msg.TendSunday
            hall.rankModule.hasRewardInfo(msg.PrizeSunday, 2, msg.RankidSunday)
            hall.eventDispatcher.emit(hall.EventDefine.RankRewardGet)
            // hall.rankModule.popupView();
          }
        }
      }
    }

    //返回排行榜领取奖励
    ;(hall.s2c as any)['onClientRankingGetPrizeAck'] = (msg: any) => {
      if (msg.Ret == 0) {
        this.rankRed = false
        hall.eventDispatcher.emit(hall.EventDefine.RankRewardEnd)
      }
    }
  }
  //排行榜通过列表有没有数据来请求新数据 --防止一直重复获取
  //30分钟倒计时就把这些列表的数据都删除了（只删除今日的和本周的）

  //---------------------           请求列表数据           --------------------------
  //请求今日排行榜信息
  sendRankDailyInfo(_reset?: boolean) {
    const message = {
      UserID: hall.userModule.userId,
      RankType: 1, //(1:日,2:周,3:历史日,4:历史周)
    }
    wsClient.send(MsgIDs.ClientRankingDataReq, message)
  }

  //请求昨日排行榜信息
  sendRanklastDailyInfo(_reset?: boolean) {
    const message = {
      UserID: hall.userModule.userId,
      RankType: 3, //(1:日,2:周,3:历史日,4:历史周)
    }
    wsClient.send(MsgIDs.ClientRankingDataReq, message)
  }

  //请求本周排行榜信息
  sendRankWeeklyListInfo(_reset?: boolean) {
    const message = {
      UserID: hall.userModule.userId,
      RankType: 2, //(1:日,2:周,3:历史日,4:历史周)
    }
    wsClient.send(MsgIDs.ClientRankingDataReq, message)
  }

  //请求上周排行榜信息
  sendRankLastWeeklyListInfo(_reset?: boolean) {
    const message = {
      UserID: hall.userModule.userId,
      RankType: 4, //(1:日,2:周,3:历史日,4:历史周)
    }
    wsClient.send(MsgIDs.ClientRankingDataReq, message)
  }

  //---------------------           请求倒计时和分数           --------------------------

  //---------------------           请求排行榜奖励           --------------------------
  //请求排行榜奖励数据
  lastSendTimeReward = 0 //上次刷新的时间
  sendRewardInfo() {
    const message = {
      UserID: hall.userModule.userId,
    }

    const secondsNow = FunctionUtils.stamp()
    if (this.lastSendTimeReward == 0 || secondsNow - this.lastSendTimeReward > 3.0) {
      wsClient.send(MsgIDs.ClientRankingPrizeGoldReq, message)
      this.lastSendTimeReward = secondsNow
    }
  }

  //请求排行榜领取奖励
  sendReward(PrizeGold: number, Tbegin: number, Tend: number) {
    const message = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      PrizeGold: PrizeGold,
      Tbegin: Tbegin,
      Tend: Tend,
    }
    wsClient.send(MsgIDs.ClientRankingGetPrizeReq, message)
  }

  //获取每日倒计时
  getDailyDownTime() {
    return this.dailyEndTime
  }

  getWeeklyDownTime() {
    return this.weeklyEndTime
  }

  //获取排行榜自己的排名数据
  getOwnListInfo(type: number) {
    //0:当日、1：昨日、2.本周、3.上周
    let list: any[] = []
    switch (type) {
      case 0:
        list = this.dailyList
        break
      case 1:
        list = this.lastDailyList
        break
      case 2:
        list = this.weeklyList
        break
      case 3:
        list = this.lastWeeklyList
        break
    }

    for (let i = 0; i < list.length; i++) {
      if (list[i].UserID == hall.userModule.userId) {
        return list[i]
      }
    }
    return null
  }

  getListInfo(type: number) {
    let list: any[] = []
    switch (type) {
      case 0:
        list = this.dailyList
        break
      case 1:
        list = this.lastDailyList
        break
      case 2:
        list = this.weeklyList
        break
      case 3:
        list = this.lastWeeklyList
        break
    }
    return list
  }

  resetRank() {
    this.sendRankDailyInfo(true)
    this.sendRanklastDailyInfo(true)
    this.sendRankWeeklyListInfo(true)
    this.sendRankLastWeeklyListInfo(true)
  }

  isLastTime(data: number) {
    if (this.lastClickTime == 0) {
      this.lastClickTime = data
    } else {
      //判断是否超过30分钟了
      if (data - this.lastClickTime > 1800000) {
        // 30分钟(1800000毫秒)
        this.resetRank()
      }
    }
  }

  hasRewardInfo(reward: number, type: number, rank: number) {
    //有排行奖励\

    this.popInfoReward = reward
    this.popInfoType = type
    this.popInfoRank = rank
  }

  popupView() {
    if (this.popInfoReward != 0 && this.popOpen) {
      hall.popupViewModule.addPopupView(PopupViews.RankRewardPanel)
      this.popOpen = false
    }
  }

  isRewardShow() {
    //排行榜有奖励吗
  }
}
